import moment from 'moment';
import { getElationPatientId } from '../../../../../util/elation';

/** Display-ready patient identifiers for the sheet. */
export type KitSheetPatient = {
  name?: string;
  birthDate?: string;
  elationPatientId?: string;
};

const formatBirthDate = (birthDate?: string) => {
  if (!birthDate) {
    return undefined;
  }
  const date = moment(birthDate, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format('M/D/YYYY') : birthDate;
};

/**
 * Reads the sheet's patient identifiers from the unmasked FHIR Patient: MyOme
 * matches the box to the patient by these values.
 */
export const getKitSheetPatient = (patient: fhir3.Patient): KitSheetPatient => {
  const name =
    patient.name?.find(({ use }) => use === 'official') ?? patient.name?.[0];
  return {
    name:
      [name?.given?.[0], name?.family].filter(Boolean).join(' ') || undefined,
    birthDate: formatBirthDate(patient.birthDate),
    elationPatientId: getElationPatientId(patient),
  };
};
